import React from "react";
import {
  Brain,
  Activity,
  Eye,
  HeartHandshake,
  ShieldCheck,
  MessageCircle,
  HandHeart,
  Home,
  RefreshCw,
  Quote,
} from "lucide-react";
import { bookFeatures } from "../mock";
import BookCover from "./BookCover";
import useReveal from "../hooks/useReveal";

const iconMap = {
  Brain,
  Activity,
  Eye,
  HeartHandshake,
  ShieldCheck,
  MessageCircle,
  HandHeart,
  Home,
  RefreshCw,
};

const iconColors = {
  Brain: "#6618D0",
  Activity: "#48B6F7",
  Eye: "#990EE5",
  HeartHandshake: "#615DD2",
  ShieldCheck: "#48B6F7",
  MessageCircle: "#6618D0",
  HandHeart: "#990EE5",
  Home: "#615DD2",
  RefreshCw: "#6618D0",
};

export default function WhatsInside() {
  const [ref, inView] = useReveal();

  return (
    <section id="book" className="relative overflow-hidden bg-[#EAE9F6] py-16 md:py-20">
      <div
        ref={ref}
        className={`reveal ${inView ? "in-view" : ""} mx-auto max-w-7xl px-5 md:px-8`}
      >
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
          {/* Book cover */}
          <div className="flex justify-center lg:col-span-3 lg:justify-start">
            <BookCover />
          </div>

          {/* Content */}
          <div className="lg:col-span-9">
            <p className="text-xs font-extrabold tracking-[0.15em] text-[#990EE5]">
              FOR THE MOMENTS WHEN KNOWING BETTER ISN'T ENOUGH
            </p>
            <h2 className="mt-2 font-serif-display text-4xl font-bold text-[#6618D0] md:text-[2.8rem]">
              What's Inside the Book
            </h2>

            <div className="mt-9 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2 lg:grid-cols-3">
              {bookFeatures.map((f) => {
                const Icon = iconMap[f.icon];
                return (
                  <div key={f.title} className="group">
                    <Icon
                      className="h-8 w-8 transition-transform group-hover:scale-110"
                      style={{ color: iconColors[f.icon] }}
                      strokeWidth={1.7}
                    />
                    <h3 className="mt-3 whitespace-pre-line font-serif-display text-[17px] font-bold leading-tight text-[#6618D0]">
                      {f.title}
                    </h3>
                    <p className="mt-2 text-[13px] leading-relaxed text-[#5a5a5a]">
                      {f.text}
                    </p>
                  </div>
                );
              })}
            </div>

            {/* Quote strip */}
            <div className="mt-10 flex items-start gap-4 rounded-xl bg-[#DCEFFB]/70 px-7 py-6">
              <Quote className="h-9 w-9 shrink-0 fill-[#48B6F7] text-[#48B6F7]" />
              <div>
                <p className="font-serif-display text-lg font-medium text-[#2a2a2a] md:text-xl">
                  You already know the mother you want to be. This book helps you
                  understand what gets in the way when pressure takes over, and
                  gives you a practical place to begin.
                </p>
                <p className="mt-1 font-serif-display text-lg font-bold text-[#990EE5] md:text-xl">
                  Coming Soon — Reserve Your Copy Today!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
